import { canAccessNavigationPath } from '@/features/auth/access-control/routeAccess';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Layout } from '../-layout/Layout';

export const Route = createFileRoute('/(app)')({
  beforeLoad: ({ context: { auth, perms }, location }) => {
    const { isAuthenticated, isAuthenticating, refreshToken } = auth;
    if (!isAuthenticating && !isAuthenticated && !refreshToken) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/login',
      });
    }

    if ((isAuthenticated || refreshToken) && !canAccessNavigationPath(location.pathname, perms)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/forbidden',
        search: {
          from: location.pathname,
        },
        replace: true,
      });
    }
  },
  component: () => <RouteComponent />,
});

function RouteComponent() {
  return <Layout />;
}
